/* Adapter for the native variant/cart components in the supplied Dawn theme.
   Only elements inside this Outlet product section are enhanced. */
(() => {
  'use strict';
  function sectionURL(element, id) {
    const url = new URL(element.dataset.url, location.origin);
    url.searchParams.set('variant', id);
    url.searchParams.set('section_id', element.dataset.originalSection || element.dataset.section);
    url.searchParams.set('view', 'online-outlet');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  customElements.whenDefined('product-info').then(() => {
    if (customElements.get('lk-outlet-product-info')) return;
    const Base = customElements.get('product-info');
    customElements.define('lk-outlet-product-info', class extends Base {
      async fetchQuantityRules() {
        const id = this.querySelector('.product-variant-id')?.value;
        if (!id || !this.input || !this.quantityForm) return;
        const loader = this.querySelector('.quantity__rules-cart .loading-overlay');
        loader?.classList.remove('hidden');
        try {
          const response = await fetch(sectionURL(this, id));
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (this.querySelector('.product-variant-id')?.value !== id) return;
          this.updateQuantityRules(this.dataset.section, html);
          this.setQuantityBoundries();
        } catch (_) { /* The native cart remains usable when a quantity refresh fails. */ }
        finally { loader?.classList.add('hidden'); }
      }
      updateQuantityRules(sectionId, html) {
        if (this.quantityForm && html.getElementById(`Quantity-Form-${sectionId}`)) {
          super.updateQuantityRules(sectionId, html);
        }
      }
    });
  });
  if (customElements.get('lk-outlet-controller')) return;
  customElements.define('lk-outlet-controller', class extends HTMLElement {
    async connectedCallback() {
      const root = this.closest('[data-outlet-product]');
      if (!root) return;
      const selectors = [...root.querySelectorAll('variant-selects, variant-radios')];
      await Promise.all(selectors.map(el => customElements.whenDefined(el.localName)));
      if (!this.isConnected) return;
      this.selectors = selectors;
      selectors.forEach(selector => {
        if (selector.dataset.outletReady) return;
        selector.dataset.outletReady = 'true';
        // Preserve the selected template and theme preview when the native selector updates the URL.
        selector.updateURL = function () {
          if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
          const url = new URL(this.dataset.url, location.origin);
          const current = new URL(location.href);
          url.searchParams.set('variant', this.currentVariant.id);
          url.searchParams.set('view', 'online-outlet');
          if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
          window.history.replaceState({}, '', url);
        };
        selector.renderProductInfo = async function () {
          const requestedId = this.currentVariant?.id;
          if (!requestedId) return;
          this.outletRequest?.abort();
          this.outletRequest = new AbortController();
          const sectionId = this.dataset.originalSection || this.dataset.section;
          const destinationId = this.dataset.section;
          const price = document.getElementById(`price-${destinationId}`);
          price?.classList.add('visibility-hidden');
          try {
            const response = await fetch(sectionURL(this, requestedId), { signal: this.outletRequest.signal });
            if (!response.ok) throw new Error('Der Preis konnte nicht aktualisiert werden. Bitte wählen Sie die Variante erneut oder laden Sie die Seite neu.');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            if (this.currentVariant?.id !== requestedId) return;
            const source = html.getElementById(`price-${sectionId}`);
            if (!source || source.querySelector('[data-outlet-price]')?.dataset.variantId !== String(requestedId)) {
              throw new Error('Der Preis der gewählten Variante ist gerade nicht verfügbar. Bitte laden Sie die Seite neu.');
            }
            for (const prefix of ['price', 'Inventory', 'Sku']) {
              const from = html.getElementById(`${prefix}-${sectionId}`);
              const to = document.getElementById(`${prefix}-${destinationId}`);
              if (!from || !to) continue;
              to.innerHTML = from.innerHTML;
              to.classList.toggle('visibility-hidden', from.classList.contains('visibility-hidden') || (prefix === 'Inventory' && !from.textContent.trim()));
            }
            const updatedButton = html.getElementById(`ProductSubmitButton-${sectionId}`);
            this.toggleAddButton(!updatedButton || updatedButton.disabled, window.variantStrings?.soldOut || 'Ausverkauft');
            root.querySelector('[data-outlet-error]')?.remove();
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: destinationId, html, variant: this.currentVariant } });
            }
          } catch (error) {
            if (error.name === 'AbortError' || this.currentVariant?.id !== requestedId) return;
            this.toggleAddButton(true, 'Bitte erneut wählen');
            price?.classList.add('visibility-hidden');
            let message = root.querySelector('[data-outlet-error]');
            if (!message) {
              message = document.createElement('p');
              message.dataset.outletError = '';
              message.setAttribute('role', 'alert');
              message.className = 'lk-outlet-editor-note';
              price?.insertAdjacentElement('afterend', message);
            }
            message.textContent = error.message;
          }
        };
      });
    }
    disconnectedCallback() { this.selectors?.forEach(el => el.outletRequest?.abort()); }
  });
})();
